export default __webpack_public_path__ + "static/media/logo.9483b8b4.png";